import React from 'react';
import AddTherapistForm from '../components/AddTherapistForm';
import TherapistTable from '../components/TherapistTable';

function AddTherapist() {
  return (
    <div>
      <AddTherapistForm />
      <TherapistTable />
    </div>
  );
}

export default AddTherapist;
